<!-- <p>visitor-detail works!</p> -->
<mat-divider></mat-divider>
<div class="visitor-detail-wrapper">
  <mat-card class="visitor-detail-card">
    <mat-card-header class="visitor-detail-card-header">
      {{ "Visitor Details" | uppercase }}
      <button mat-mini-fab (click)="onClose()">
        <mat-icon>clear</mat-icon>
      </button>
    </mat-card-header>
    <mat-card-content class="visitor-detail-card-content">
      <form [formGroup]="showVisitorDetailsForm">
        <mat-grid-list
          [cols]="screenSize == ScreenType.Mobile ? 1 : 4"
          rowHeight="150px"
          [gutterSize]="'10px'"
        >
          <mat-grid-tile
            [rowspan]="screenSize == ScreenType.Mobile ? 13 : 7"
            [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
          >
            <div class="internalMatGrid">
              <mat-grid-list
                [cols]="screenSize == ScreenType.Mobile ? 1 : 2"
                rowHeight="90px"
              >
                <mat-grid-tile [rowspan]="2">
                  <div class="visitor-image">
                    <img [src]="profilePicture" alt="Profile Picture" />
                  </div>
                </mat-grid-tile>
                <mat-grid-tile [rowspan]="2">
                  <div class="visitor-image">
                    <img [src]="IdentityId" alt="Identity Id" /></div
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Visitor Id</mat-label>
                    <input
                      [readonly]="true"
                      matInput
                      formControlName="visitorID"
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>First Name</mat-label>
                    <input
                      [readonly]="!isUpdateVisitorDetails"
                      formControlName="firstName"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Last Name</mat-label>
                    <input
                      [readonly]="!isUpdateVisitorDetails"
                      formControlName="lastName"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <input [readonly]="true" formControlName="email" matInput />
                    <mat-label>Visitor Email</mat-label>
                  </mat-form-field></mat-grid-tile
                >
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Visitor Contact</mat-label>
                    <input
                      readonly
                      matInput
                      formControlName="phoneNumber"
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Host Name</mat-label>
                    <input
                      readonly
                      matInput
                      formControlName="hostName"
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Visit Purpose</mat-label>
                    <input
                      [readonly]="!isUpdateVisitorDetails"
                      formControlName="purpose"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Visit Date</mat-label>
                    <input
                      readonly
                      formControlName="visitDateTime"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Check In</mat-label>
                    <input
                      readonly
                      formControlName="checkIn"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Check Out</mat-label>
                    <input
                      readonly
                      formControlName="checkOut"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Visitor Category</mat-label>
                    <input
                      readonly
                      matInput
                      formControlName="visitorCategory"
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile *ngIf="!isUpdatePassValidty"
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Pass Validity</mat-label>
                    <input
                      matInput
                      formControlName="ePassValidity"
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile *ngIf="isUpdatePassValidty"
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Choose Date</mat-label>

                    <input
                      matInput
                      readonly
                      formControlName="newEPassValidity"
                      [matDatepicker]="Datepicker"
                      [min]="minDate"
                      [max]="maxDate"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="Datepicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #Datepicker></mat-datepicker>
                  </mat-form-field>
                </mat-grid-tile>
                <mat-grid-tile
                  *ngIf="selectedVisitorDetails.visitorType === '3'"
                >
                  <div class="checkbox-container">
                    <mat-checkbox formControlName="isTwoFactor"
                      >Enable 2 factor Auth</mat-checkbox
                    >
                  </div>
                </mat-grid-tile>
                <mat-grid-tile
                  *ngIf="
                    showVisitorDetailsForm.controls['isLocationVerify'].value
                  "
                >
                  <div class="checkbox-container">
                    <mat-checkbox formControlName="isLocationVerify"
                      >Enable location based verification</mat-checkbox
                    >
                  </div>
                </mat-grid-tile>
                <mat-grid-tile
                  *ngIf="
                    showVisitorDetailsForm.controls['isLocationVerify'].value
                  "
                >
                  <div class="div-button-wrapper">
                    <div class="location-content">
                      <mat-form-field
                        subscriptSizing="dynamic"
                        appearance="outline"
                      >
                        <mat-label>Visitor Location re</mat-label>
                        <input
                          *ngIf="viewIncident != null"
                          matInput
                          [value]="viewIncident"
                        />
                        <input
                          *ngIf="viewIncident == null"
                          formControlName="visitorLocation"
                          [readonly]="!isUpdateVisitorDetails"
                          matInput
                        />
                      </mat-form-field>
                      <button
                        (click)="onClickOpenMap()"
                        mat-icon-button
                        [disabled]="!isUpdateVisitorDetails"
                      >
                        <mat-icon>open_in_new</mat-icon>
                      </button>
                    </div>
                  </div>
                </mat-grid-tile>
                <mat-grid-tile>
                  <div class="button-tile">
                    <button
                      [disabled]="!isUpdateVisitorDetails"
                      (click)="togglePassValidity()"
                      mat-raised-button
                    >
                      {{ isUpdatePassValidty ? "Cancel" : "Extend Validity" }}
                    </button>
                  </div>
                </mat-grid-tile>
                <mat-grid-tile>
                  <div class="button-tile">
                    <button (click)="toggleVisitorEdit()" mat-raised-button>
                      {{ isUpdateVisitorDetails ? "Update" : "Edit" }}
                    </button>
                  </div>
                </mat-grid-tile>
                <mat-grid-tile>
                  <div class="button-tile">
                    <button (click)="onRemoveVisitor()" mat-raised-button>
                      Remove
                    </button>
                  </div>
                </mat-grid-tile>
                <mat-grid-tile>
                  <div class="button-tile">
                    <button (click)="onClose()" mat-raised-button>Close</button>
                  </div>
                </mat-grid-tile>
                <mat-grid-tile>
                  <div class="button-tile">
                    <button (click)="visitorTimelineToggle()" mat-raised-button>
                      {{ isShowTime ? "Close Timeline" : "Show Timeline" }}
                    </button>
                  </div>
                </mat-grid-tile>
              </mat-grid-list>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            [rowspan]="screenSize == ScreenType.Mobile ? 5 : 7"
            [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
          >
            <div
              [ngStyle]="{
                'justify-content':
                  screenSize == ScreenType.Mobile ? 'flex-start' : 'flex-start'
              }"
              class="internalMatGridAssetTable"
            >
              <div class="details-graph-wrapper">
                <app-visitor-timeline-graph-container
                  [visitorData]="selectedVisitorDetails"
                  [orgUsersData]="usersList"
                  [isGraph]="true"
                  (closeVisitorDetail)="onClose()"
                ></app-visitor-timeline-graph-container>
              </div>
              <div class="details-graph-wrapper">
                <app-visitor-timeline-graph-container
                  [visitorData]="selectedVisitorDetails"
                  [orgUsersData]="usersList"
                  [isGraph]="false"
                  [selectedCommentId]="selectedCommentId"
                  (closeVisitorDetail)="onClose()"
                  (postVisitorComment)="onPostVisitorComment($event)"
                ></app-visitor-timeline-graph-container>
              </div>
              <div class="visitor-timeline-button"></div>
            </div>
          </mat-grid-tile>
          <!-- <mat-grid-tile [rowspan]="screenSize == ScreenType.Mobile ? 6 : 7">
            <div class="internalMatGridAssetTable">
              <div class="visitor-image">
                <img [src]="profilePicture" alt="Profile Picture" />
              </div>
              <div class="visitor-image">
                <img [src]="IdentityId" alt="Identity Id" />
              </div>
              <div class="visitor-timeline-button">
                <button (click)="visitorTimelineToggle()" mat-raised-button>
                  {{ isShowTime ? "Close Timeline" : "Show Timeline" }}
                </button>
              </div>
            </div>
          </mat-grid-tile> -->
        </mat-grid-list>
      </form>
    </mat-card-content>
    <!-- <mat-card-actions></mat-card-actions> -->
  </mat-card>
  <br />
</div>
<!-- VisitorRemove Dialog Content -- -->
<ng-template #RemoveVisitorDialog>
  <h2 matDialogTitle>Remove Visitor!</h2>
  <mat-dialog-content>
    <div class="mat-dialog-content-Remove">
      <b><i> Do you really want to remove this Visitor!</i></b>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="true">Yes</button>
    <button mat-raised-button [mat-dialog-close]="false" cdkFocusInitial>
      No
    </button>
  </mat-dialog-actions>
</ng-template>
